
function localeCartUrl(path) {
  const localeMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\//i);
  const prefix = localeMatch ? '/' + localeMatch[1] : '';
  return prefix + '/' + path.replace(/^\//, '');
}

/* ══════════════════════════════════════
   page.landing.liquid  →  data-page="collaglo-lp"
══════════════════════════════════════ */

(function () {
  if (!document.body || document.body.dataset.page !== 'collaglo-lp') return;

  const tabBtns = document.querySelectorAll('.tab-btn');
  const grid300 = document.getElementById('tab-300');
  const grid500 = document.getElementById('tab-500');

  function switchTab(size) {
    tabBtns.forEach(btn => btn.classList.toggle('active', btn.dataset.tab === size));
    if (grid300) grid300.style.display = size === '300' ? '' : 'none';
    if (grid500) grid500.style.display = size === '500' ? '' : 'none';
  }

  tabBtns.forEach(btn => btn.addEventListener('click', () => switchTab(btn.dataset.tab)));

  function selectCard(card) {
    const grid = card.closest('.bundle-grid');
    grid.querySelectorAll('.bundle-card').forEach(c => {
      c.classList.remove('active');
      const cta = c.querySelector('.bundle-cta');
      if (cta) cta.className = 'bundle-cta outline';
    });
    card.classList.add('active');
    const cta = card.querySelector('.bundle-cta');
    if (cta) cta.className = 'bundle-cta filled';
  }

  document.querySelectorAll('.bundle-card').forEach(card => {
    card.addEventListener('click', () => selectCard(card));
  });

  const urlSize = new URLSearchParams(window.location.search).get('size');
  if (urlSize === '300' || urlSize === '500') switchTab(urlSize);
})();

/* ══════════════════════════════════════
   page.pdp.liquid  →  data-page="collaglo-pp"
══════════════════════════════════════ */

(function () {
  if (!document.body || document.body.dataset.page !== 'collaglo-pp') return;

  fetch(localeCartUrl('cart.js'), {
    method: 'GET'
  }).then(response => console.log(response.json()));

  const pdpMode        = document.querySelector('.product-layout')?.dataset.pdpMode || 'bundle';
  let currentSize      = '300';
  let currentPlan      = 'elite';
  let isOneTime        = false;
  let currentType      = 'bundel';
  let currentBundelQty = '3x';

  // ── Gallery ───────────────────────────────────────────
  let gallerySlideIndex   = 0;
  const galleryTrack      = document.getElementById('galleryTrack');
  const gallerySlideCount = galleryTrack ? galleryTrack.children.length : 0;
  const galleryPrevBtn    = document.getElementById('galleryPrev');
  const galleryNextBtn    = document.getElementById('galleryNext');

  function goToGallerySlide(slideIndex) {
    if (!galleryTrack) return;
    gallerySlideIndex = Math.max(0, Math.min(slideIndex, gallerySlideCount - 1));
    galleryTrack.style.transform = `translateX(-${gallerySlideIndex * 100}%)`;
    document.querySelectorAll('.gallery-thumb').forEach((thumb, i) =>
      thumb.classList.toggle('active', i === gallerySlideIndex));
    if (galleryPrevBtn) galleryPrevBtn.disabled = gallerySlideIndex === 0;
    if (galleryNextBtn) galleryNextBtn.disabled = gallerySlideIndex === gallerySlideCount - 1;
  }
  if (galleryPrevBtn) galleryPrevBtn.addEventListener('click', () => goToGallerySlide(gallerySlideIndex - 1));
  if (galleryNextBtn) galleryNextBtn.addEventListener('click', () => goToGallerySlide(gallerySlideIndex + 1));
  document.querySelectorAll('.gallery-thumb').forEach((thumb, i) =>
    thumb.addEventListener('click', () => goToGallerySlide(i)));

  // ── Reviews carousel ─────────────────────────────────
  let reviewCarouselIndex   = 0;
  const reviewCarouselTrack = document.getElementById('reviewsCarousel');
  const reviewCarouselCards = reviewCarouselTrack ? Array.from(reviewCarouselTrack.children) : [];
  const reviewCarouselCount = reviewCarouselCards.length;
  const reviewDotsContainer = document.getElementById('revDots');
  const revPrevBtn          = document.getElementById('revPrev');
  const revNextBtn          = document.getElementById('revNext');

  if (reviewDotsContainer) {
    reviewCarouselCards.forEach((_, i) => {
      const dot = document.createElement('div');
      dot.className = 'rev-dot' + (i === 0 ? ' active' : '');
      dot.addEventListener('click', () => goToReviewSlide(i));
      reviewDotsContainer.appendChild(dot);
    });
  }

  function goToReviewSlide(slideIndex) {
    if (!reviewCarouselTrack) return;
    reviewCarouselIndex = Math.max(0, Math.min(slideIndex, reviewCarouselCount - 1));
    reviewCarouselTrack.style.transform = `translateX(-${reviewCarouselIndex * 100}%)`;
    document.querySelectorAll('.rev-dot').forEach((dot, i) =>
      dot.classList.toggle('active', i === reviewCarouselIndex));
    if (revPrevBtn) revPrevBtn.style.opacity = reviewCarouselIndex === 0 ? '0.3' : '1';
    if (revNextBtn) revNextBtn.style.opacity = reviewCarouselIndex === reviewCarouselCount - 1 ? '0.3' : '1';
  }
  if (revPrevBtn) revPrevBtn.addEventListener('click', () => goToReviewSlide(reviewCarouselIndex - 1));
  if (revNextBtn) revNextBtn.addEventListener('click', () => goToReviewSlide(reviewCarouselIndex + 1));
  goToReviewSlide(0);

  // ── Radio visual enhancement ──────────────────────────
  function applyRadioVisuals(group) {
    group.querySelectorAll('.plan-option').forEach(option => {
      const inputEl   = option.querySelector('input');
      const isChecked = inputEl && inputEl.checked;
      option.style.borderColor = isChecked ? 'var(--green)' : '';
      option.style.boxShadow   = isChecked ? '0 0 0 1px var(--green)' : '';
      option.style.background  = isChecked ? 'var(--green-bg)' : 'white';
      const dotEl   = option.querySelector('.plan-radio-dot');
      const radioEl = option.querySelector('.plan-radio');
      if (dotEl)   dotEl.style.background    = isChecked ? 'var(--green)' : 'transparent';
      if (radioEl) radioEl.style.borderColor = isChecked ? 'var(--green)' : '';
    });
  }

  document.querySelectorAll('.plan-option input').forEach(input => {
    input.addEventListener('change', () => {
      const group = input.closest('.plan-options');
      if (group) applyRadioVisuals(group);
      if (pdpMode === 'subscription') {
        isOneTime   = false;
        currentPlan = input.value;
        const ctaBtn = document.getElementById('ctaBtn');
        if (ctaBtn) ctaBtn.textContent = window.COLLAGLO_PDP_I18N.activateRoutine;
      }
      if (pdpMode === 'combo') {
        if (input.name === 'b300' || input.name === 'b500') currentBundelQty = input.value;
        if (input.name === 'abo300' || input.name === 'abo500') currentPlan = input.value;
      }
    });
    if (input.checked) input.dispatchEvent(new Event('change'));
  });

  // ── Size selection ────────────────────────────────────
  function selectSize(size) {
    currentSize = size;
    document.querySelectorAll('.size-btn').forEach(btn =>
      btn.classList.toggle('active', btn.dataset.size === size));
    const o300 = document.getElementById('o300');
    const o500 = document.getElementById('o500');
    if (o300) o300.style.display = size === '300' ? '' : 'none';
    if (o500) o500.style.display = size === '500' ? '' : 'none';
    document.querySelectorAll('.serving-300').forEach(el => { el.style.display = size === '300' ? '' : 'none'; });
    document.querySelectorAll('.serving-500').forEach(el => { el.style.display = size === '500' ? '' : 'none'; });
    if (pdpMode === 'subscription') updateAllPlanPrices();
    if (pdpMode === 'combo') {
      const abo300 = document.getElementById('abo300');
      const abo500 = document.getElementById('abo500');
      if (abo300) abo300.style.display = size === '300' ? '' : 'none';
      if (abo500) abo500.style.display = size === '500' ? '' : 'none';
      updateEenmaligPrice();
    }
  }

  document.querySelectorAll('.size-btn').forEach(btn =>
    btn.addEventListener('click', () => selectSize(btn.dataset.size)));

  // ── Bundle mode ───────────────────────────────────────
  if (pdpMode === 'bundle') {
    const BUNDLE_VARIANT_MAP = {
      '53136310075734': { size: '300', qty: '1x' },
      '53136310108502': { size: '300', qty: '3x' },
      '53136310174038': { size: '500', qty: '1x' },
      '53136310206806': { size: '500', qty: '3x' },
      '53136310239574': { size: '500', qty: '5x' },
    };

    const urlVariantParam = new URLSearchParams(window.location.search).get('variant');
    if (urlVariantParam && BUNDLE_VARIANT_MAP[urlVariantParam]) {
      const { size, qty } = BUNDLE_VARIANT_MAP[urlVariantParam];
      selectSize(size);
      const radio = document.querySelector(`#o${size} input[value="${qty}"]`);
      if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change')); }
    }

    document.getElementById('ctaBtn').addEventListener('click', function () {
      const activeGroup   = document.getElementById('o' + currentSize);
      const checkedInput  = activeGroup ? activeGroup.querySelector('input:checked') : null;
      const selectedLabel = checkedInput ? checkedInput.closest('.plan-option') : null;
      const variantId     = selectedLabel ? selectedLabel.dataset.variantId : null;
      if (!variantId) return;

      const ctaBtn       = document.getElementById('ctaBtn');
      ctaBtn.disabled    = true;
      ctaBtn.textContent = window.COLLAGLO_PDP_I18N.loading;

      fetch(localeCartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
      })
        .then(response => {
          if (response.ok) window.location.href = localeCartUrl('cart');
        })
        .catch(() => { window.location.href = localeCartUrl('cart'); })
        .finally(() => {
          ctaBtn.disabled    = false;
          ctaBtn.textContent = window.COLLAGLO_PDP_I18N.addToCart;
        });
    });
  }

  // ── Subscription mode ─────────────────────────────────
  function updateAllPlanPrices() {
    const sizeData = window.COLLAGLO_PDP_DATA.subscription[currentSize];
    ['elite', 'glow', 'steady', 'casual'].forEach(planKey => {
      const planData   = sizeData[planKey];
      const priceEl    = document.getElementById('price-'    + planKey);
      const savingEl   = document.getElementById('saving-'   + planKey);
      const originalEl = document.getElementById('original-' + planKey);
      const subEl      = document.getElementById('sub-'      + planKey);
      const discEl     = document.getElementById('disc-'     + planKey);
      if (priceEl)    priceEl.textContent    = planData.price;
      if (savingEl)   savingEl.textContent   = planData.ppp;
      if (originalEl) originalEl.textContent = planData.original;
      if (subEl)      subEl.textContent      = planData.sub;
      if (discEl)     discEl.textContent     = planData.discount;
    });
    const oneTimePriceEl = document.getElementById('oneTimePrice');
    if (oneTimePriceEl) oneTimePriceEl.textContent = sizeData.oneTime.price;
  }

  if (pdpMode === 'subscription') {
    const ctaBtn = document.getElementById('ctaBtn');
    if (ctaBtn) ctaBtn.textContent = window.COLLAGLO_PDP_I18N.activateRoutine;

    const oneTimeBtnEl = document.getElementById('oneTimeBtn');
    if (oneTimeBtnEl) oneTimeBtnEl.addEventListener('click', () => {
      isOneTime   = true;
      currentPlan = 'oneTime';
      document.querySelectorAll('.plan-option input').forEach(i => { i.checked = false; });
      document.querySelectorAll('.plan-option').forEach(opt => {
        opt.style.borderColor = '';
        opt.style.boxShadow   = '';
        opt.style.background  = 'white';
        const dot   = opt.querySelector('.plan-radio-dot');
        const radio = opt.querySelector('.plan-radio');
        if (dot)   dot.style.background    = 'transparent';
        if (radio) radio.style.borderColor = '';
      });
      if (ctaBtn) ctaBtn.textContent = window.COLLAGLO_PDP_I18N.addOneTime;
    });

    if (ctaBtn) ctaBtn.addEventListener('click', function () {
      const sizeData    = window.COLLAGLO_PDP_DATA.subscription[currentSize];
      const variantData = (isOneTime || currentPlan === 'oneTime') ? sizeData.oneTime : sizeData[currentPlan];
      const cartPayload = { id: variantData.id, quantity: 1 };
      if (variantData.sellingPlanId) cartPayload.selling_plan = variantData.sellingPlanId;

      fetch(localeCartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartPayload),
      })
        .then(response => { if (response.ok) window.location.href = localeCartUrl('cart'); })
        .catch(() => { window.location.href = '/cart'; });
    });

    const SUBSCRIPTION_VARIANT_MAP = {
      '53452564234582': { size: '300', plan: 'elite'   },
      '53452564267350': { size: '300', plan: 'glow'    },
      '53452564300118': { size: '300', plan: 'steady'  },
      '53452564332886': { size: '300', plan: 'casual'  },
      '53452564201814': { size: '300', plan: 'oneTime' },
      '53452564398422': { size: '500', plan: 'elite'   },
      '53452564431190': { size: '500', plan: 'glow'    },
      '53452564463958': { size: '500', plan: 'steady'  },
      '53452564496726': { size: '500', plan: 'casual'  },
      '53452564365654': { size: '500', plan: 'oneTime' },
    };

    const urlSubVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlSubVariant && SUBSCRIPTION_VARIANT_MAP[urlSubVariant]) {
      const { size, plan } = SUBSCRIPTION_VARIANT_MAP[urlSubVariant];
      selectSize(size);
      if (plan === 'oneTime') {
        if (oneTimeBtnEl) oneTimeBtnEl.click();
      } else {
        const planRadio = document.querySelector('input[name="plan"][value="' + plan + '"]');
        if (planRadio) { planRadio.checked = true; planRadio.dispatchEvent(new Event('change')); }
      }
    }

    updateAllPlanPrices();
  }

  // ── Combo mode ────────────────────────────────────────
  function updateEenmaligPrice() {
    const priceEl = document.getElementById('eenmaligLinkPrice');
    if (priceEl) priceEl.textContent = window.COLLAGLO_PDP_DATA.bundle[currentSize]['1x'].price;
  }

  function setType(type) {
    currentType = type;
    document.querySelectorAll('.ttab').forEach(btn =>
      btn.classList.toggle('active', btn.dataset.type === type));
    const typeBundel   = document.getElementById('type-bundel');
    const typeAbo      = document.getElementById('type-abo');
    const typeEenmalig = document.getElementById('type-eenmalig');
    if (typeBundel)   typeBundel.style.display   = type === 'bundel'    ? '' : 'none';
    if (typeAbo)      typeAbo.style.display       = type === 'abo'       ? '' : 'none';
    if (typeEenmalig) {
      typeEenmalig.style.display    = type === 'eenmalig' ? ''        : 'none';
      typeEenmalig.style.visibility = type === 'eenmalig' ? 'visible' : 'hidden';
      typeEenmalig.style.height     = type === 'eenmalig' ? ''        : '0';
      typeEenmalig.style.overflow   = type === 'eenmalig' ? ''        : 'hidden';
    }
    const ctaBtn = document.getElementById('ctaBtn');
    if (ctaBtn) ctaBtn.textContent = type === 'abo' ? window.COLLAGLO_PDP_I18N.activateRoutine : window.COLLAGLO_PDP_I18N.addToCart;
    const eenmaligLinkEl = document.getElementById('eenmaligLink');
    if (eenmaligLinkEl) eenmaligLinkEl.style.display = type === 'abo' ? '' : 'none';
    updateEenmaligPrice();
  }

  if (pdpMode === 'combo') {
    const urlParams = new URLSearchParams(window.location.search);
    const paramSize = urlParams.get('size');
    const paramType = urlParams.get('type');
    const paramQty  = urlParams.get('qty');
    const paramPlan = urlParams.get('plan');

    if (paramSize === '300' || paramSize === '500') currentSize = paramSize;
    if (paramType === 'bundel' || paramType === 'abonnement' || paramType === 'eenmalig') {
      currentType = paramType === 'abonnement' ? 'abo' : paramType;
    }
    if (paramQty  && ['1x', '3x', '5x'].includes(paramQty))                              currentBundelQty = paramQty;
    if (paramPlan && ['elite', 'glow', 'steady', 'casual'].includes(paramPlan))          currentPlan      = paramPlan;

    selectSize(currentSize);
    setType(currentType);

    const initialBundelRadio = document.querySelector('input[name="b'   + currentSize + '"][value="' + currentBundelQty + '"]');
    if (initialBundelRadio) { initialBundelRadio.checked = true; initialBundelRadio.dispatchEvent(new Event('change')); }
    const initialAboRadio = document.querySelector('input[name="abo' + currentSize + '"][value="' + currentPlan + '"]');
    if (initialAboRadio) { initialAboRadio.checked = true; initialAboRadio.dispatchEvent(new Event('change')); }

    document.querySelectorAll('.ttab').forEach(btn =>
      btn.addEventListener('click', () => setType(btn.dataset.type)));

    document.querySelectorAll('input[name="b300"], input[name="b500"]').forEach(radio =>
      radio.addEventListener('change', () => { currentBundelQty = radio.value; }));

    document.querySelectorAll('input[name="abo300"], input[name="abo500"]').forEach(radio =>
      radio.addEventListener('change', () => { currentPlan = radio.value; }));

    document.querySelectorAll('input[name="een"]').forEach(radio =>
      radio.addEventListener('change', () => selectSize(radio.value)));

    const eenmaligLink = document.getElementById('eenmaligLink');
    if (eenmaligLink) eenmaligLink.addEventListener('click', e => { e.preventDefault(); setType('eenmalig'); });

    const addToCartBtn = document.getElementById('ctaBtn');
    if (addToCartBtn) addToCartBtn.addEventListener('click', function () {
      const data        = window.COLLAGLO_PDP_DATA;
      let variantId;
      let sellingPlanId = null;

      if (currentType === 'bundel') {
        const selectedBundle = data.bundle[currentSize][currentBundelQty] || data.bundle[currentSize]['3x'];
        variantId = selectedBundle.id;
      } else if (currentType === 'abo') {
        const planData = data.subscription[currentSize][currentPlan];
        variantId     = planData.id;
        sellingPlanId = planData.sellingPlanId || null;
      } else {
        variantId = data.bundle[currentSize]['1x'].id;
      }

      const cartPayload = { id: variantId, quantity: 1 };
      if (sellingPlanId) cartPayload.selling_plan = sellingPlanId;

      fetch(localeCartUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartPayload),
      })
        .then(() => { window.location.href = localeCartUrl('cart'); })
        .catch(() => { window.location.href = '/cart'; });
    });
  }
})();